import { Converter } from '../types/converter';

export const luminousIntensityConverter: Converter = {
  id: 'luminousIntensity',
  name: 'Luminous Intensity Converter',
  icon: 'Sun',
  categories: ['light'],
  units: [
    { name: 'Candle (international)', symbol: 'c', factor: 1 },
    { name: 'Candle (German)', symbol: 'c (German)', factor: 1.0526 },
    { name: 'Candle (UK)', symbol: 'c (UK)', factor: 1.0417 },
    { name: 'Decimal candle', symbol: 'decimal candle', factor: 1.0182 },
    { name: 'Candle (pentane)', symbol: 'c (pentane)', factor: 1.0437 },
    { name: 'Pentane candle (10 candle power)', symbol: 'pentane candle (10 cp)', factor: 10.437 },
    { name: 'Hefner candle', symbol: 'hefner candle', factor: 0.9033 },
    { name: 'Carcel unit', symbol: 'carcel unit', factor: 9.6 },
    { name: 'Bougie decimal', symbol: 'bougie decimal', factor: 1.0182 },
    { name: 'Lumen/steradian', symbol: 'lm/sr', factor: 1 }
  ]
};
